import { Dom7 as $ } from "framework7/bundle";
import { api } from "./api.js";
import { localizeStr } from "./i18n.js";

let app = null;

// Das Notiz-Sheet ist unabhaengig vom Thesaurus-Sheet und wird hier
// verwaltet - nicht ueber window.dynamicSheet.
let noteSheet = null;

export function installNotes(f7) {
    app = f7;
}

function closeNoteDialog() {
    if (noteSheet) {
        noteSheet.close();
        noteSheet = null;
    }
}

/**
 * Notiz-Dialog als Sheet von unten - neu oder zum Bearbeiten.
 * options.note:      bestehende Notiz {id, bodytext} -> Bearbeiten (mit Loeschen)
 * options.therapyId: optionaler Therapie-Bezug (nur neu)
 * options.onSaved:   Callback nach Speichern oder Loeschen
 */
export function openNoteDialog(options = {}) {
    closeNoteDialog();
    const note = options.note || null;

    noteSheet = app.sheet.create({
        swipeToClose: true,
        content: `
          <div class="sheet-modal sheet-new-note">
            <div class="toolbar">
              <div class="toolbar-inner">
                <div><b>${localizeStr(note ? "panel_notes_dialog_edit_title" : "panel_notes_dialog_title")}</b></div>
              </div>
            </div>
            <div class="sheet-modal-inner">
              <div class="block block-input">
                <textarea class="note-bodytext notes" name="bodytext"></textarea>
                <a class="standard-button btnSaveNote" href="#">${localizeStr("panel_notes_dialog_save")}</a>
                ${note ? `<a class="standard-button button-outline btnDeleteNote margin-top-half" href="#">${localizeStr("panel_notes_dialog_delete")}</a>` : ""}
              </div>
            </div>
          </div>`,
        on: {
            opened(sheet) {
                const $el = $(sheet.el);
                const sheetMargin = 60;
                const height = $el.find(".toolbar").outerHeight() + $el.find(".sheet-modal-inner .block").outerHeight() + sheetMargin;
                $el.css("height", height + "px");
                $el.find(".note-bodytext").focus();
            },
            closed(sheet) {
                if (noteSheet === sheet) noteSheet = null;
            }
        }
    });

    const $sheet = $(noteSheet.el);
    if (note) $sheet.find(".note-bodytext").val(note.bodytext || "");

    const done = () => {
        closeNoteDialog();
        if (typeof options.onSaved === "function") options.onSaved();
    };

    $sheet.find(".btnSaveNote").on("click", function (e) {
        e.preventDefault();
        const bodytext = $sheet.find(".note-bodytext").val();
        const request = note ? updateNote(note.id, bodytext) : saveNote({ bodytext, therapyId: options.therapyId || null });
        request.then(done).catch(() => {});
    });

    $sheet.find(".btnDeleteNote").on("click", function (e) {
        e.preventDefault();
        app.dialog.confirm(localizeStr("panel_notes_delete_confirm"), localizeStr("panel_notes_dialog_delete"), function () {
            deleteNote(note.id).then(done).catch(() => {});
        });
    });

    noteSheet.open();
}

function requireText(bodytext) {
    const text = (bodytext || "").trim();
    if (text === "") {
        $(".note-bodytext").addClass("error");
        return null;
    }
    return text;
}

/** Notiz speichern. Leere Notizen werden nicht gesendet. */
export function saveNote({ bodytext, therapyId = null }) {
    const text = requireText(bodytext);
    if (text === null) return Promise.reject(new Error("empty note"));
    return api.post("/frontend/note/post", { bodytext: text, therapy_id: therapyId });
}

export function updateNote(id, bodytext) {
    const text = requireText(bodytext);
    if (text === null) return Promise.reject(new Error("empty note"));
    return api.post("/frontend/note/update", { id, bodytext: text });
}

export function deleteNote(id) {
    return api.post("/frontend/note/delete", { id });
}

/** Notizen desselben Zeitraums optisch zu einer Karte verbinden. */
export function arrangeNotes() {
    for (let span = 1; span <= 4; span++) {
        const items = $(".time-span-" + span);
        if (items.length > 1) {
            items.addClass("card-connect");
            items.eq(0).addClass("first");
            items.eq(items.length - 1).addClass("last");
        }
    }
}
